// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/den-" + {"303":"widget","343":"cart-css","384":"modern-css","949":"cart"}[chunkId] + ".chunk.js";
};